import React from "react";
import { GeoJSON } from "react-leaflet";
import { reprojectWgToUtmPoint } from "../../../common/utmDef";
import {
  getCurrentObjectType,
  getCurrentObjectSubtype,
} from "../../../containers/Domain/geo-selectors/index";
import { stylePolygon } from "../../../utils/polygons/polygonStyle";
import { point } from "@turf/helpers";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import { multiPolygon } from "@turf/helpers";
import { throttle } from "lodash";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

class NestedRasterGeoJson extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onEachRasterGeoJsonFeature =
      this.onEachRasterGeoJsonFeature.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);

    this.activeTooltip = null;
  }

  componentDidMount() {
    if (
      this.props.parentRasterPreviewRef?.current?.leafletElement &&
      this.props.parentRasterPreview
    )
      this.props.parentRasterPreviewRef.current.leafletElement
        .clearLayers()
        .addData(this.props.parentRasterPreview);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (!prevProps.isParentRasterPreviewVisible &&
        this.props.isParentRasterPreviewVisible) ||
      (this.props.isParentRasterPreviewVisible &&
        this.props.parentRasterPreview &&
        this.props.parentRasterPreview !== prevProps.parentRasterPreview)
    ) {
      this.props.parentRasterPreviewRef.current.leafletElement
        .clearLayers()
        .addData(this.props.parentRasterPreview);
    }
  }

  onEachRasterGeoJsonFeature = (feature, layer) => {
    this.activeTooltip = null;
    const throttledMouseMove = throttle(
      this.handleMouseMove(layer, feature),
      25
    );

    layer.on("mousemove", throttledMouseMove);
    layer.on("mouseout", this.handleMouseOut(layer));
  };

  handleMouseMove = (layer, feature) => (e) => {
    const { lat, lng } = e.latlng;
    const properties = feature.properties;
    const currentCursorCoordsUtm = reprojectWgToUtmPoint(
      {
        lat: lat,
        lng: lng,
      },
      this.props.crsDef
    );
    const coordsInfoLat = Math.ceil(
      (currentCursorCoordsUtm.lat - this.props.parentRasterPreviewBbox[1]) /
        this.props.parentGridSize
    );
    const coordsInfoLng = Math.ceil(
      (currentCursorCoordsUtm.lng - this.props.parentRasterPreviewBbox[0]) /
        this.props.parentGridSize
    );

    let childDiv = "";

    if (this.props.isChildRasterPreviewVisible) {
      const childInfoLat = Math.ceil(
        (currentCursorCoordsUtm.lat - this.props.childRasterPreviewBbox[1]) /
          this.props.childGridSize
      );

      
      const childInfoLng = Math.ceil(
        (currentCursorCoordsUtm.lng - this.props.childRasterPreviewBbox[0]) /
          this.props.childGridSize
      );
      if (childInfoLat > 0 && childInfoLng > 0) {
        const clickedPoint = point([lng, lat]);

        this.props.childRasterPreview.features.forEach((feature) => {
          if (feature.geometry.type === "MultiPolygon") {
            const multiPolygonn = multiPolygon(feature.geometry.coordinates);

            if (booleanPointInPolygon(clickedPoint, multiPolygonn)) {
              childDiv =
                "<div style='z-index:100000'><div style='background:white; min-width:120px; padding:1px 3px 1px 3px'>" +
                `<div><strong>Child: ${
                  feature.properties.t === 99
                    ? "Raster filling"
                    : feature.properties.t === 98
                    ? "Buffered area"
                    : this.props.t(getCurrentObjectType(feature.properties))
                }</strong>
             </div>
             ` +
                `<div> ${
                  feature.properties.t === 99 || feature.properties.t === 98
                    ? ""
                    : this.props.t(getCurrentObjectSubtype(feature.properties))
                }</div>` +
                `<div>x: ${childInfoLng}</div>` +
                `<div>y: ${childInfoLat}</div>` +
                "</div>";
            }
          }
        });
      }
    }

    const content =
      "<div style='z-index:100000'><div style='background:white; min-width:120px; padding:1px 3px 1px 3px'>" +
      `<div><strong>Parent: ${
        properties.t === 99
          ? "Raster filling"
          : properties.t === 98
          ? "Buffered area"
          : this.props.t(getCurrentObjectType(properties))
      }</strong>
 </div>
 ` +
      `<div> ${
        properties.t === 99 || properties.t === 98
          ? ""
          : this.props.t(getCurrentObjectSubtype(properties))
      }</div>` +
      `<div>x: ${coordsInfoLng}</div>` +
      `<div>y: ${coordsInfoLat}</div>` +
      "</div>" +
      childDiv;

    if (this.activeTooltip) {
      this.activeTooltip.unbindTooltip();
    }

    this.activeTooltip = layer
      .bindTooltip(content, {
        permanent: false,
        direction: "top",
        sticky: true,
        opacity: 0.9,
      })
      .openTooltip(e.latlng);
  };

  handleMouseOut = (layer) => () => {
    if (this.activeTooltip) {
      this.activeTooltip.unbindTooltip();
      this.activeTooltip = null;
    }
  };

  render() {
    return (
      <>
        {this.props.isParentRasterPreviewVisible && (
          <GeoJSON
            ref={this.props.parentRasterPreviewRef}
            style={(x) => {
              return stylePolygon(x, false, this.props.inputPalmTypesPalette);
            }}
            onEachFeature={this.onEachRasterGeoJsonFeature}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    parentRasterPreview: state.rasterArea.parentRasterPreview,
    isParentRasterPreviewVisible: state.rasterArea.isParentRasterPreviewVisible,
    inputPalmTypesPalette:
      state.userSettings?.settings?.visualizationPresets
        ?.inputPalmTypesPalette || {},
    parentRasterPreviewBbox: state.rasterArea.parentRasterPreviewBbox,
    crsDef: state.map.crsDef,
    parentGridSize: state.rasterArea.parentGridSize,
    childRasterPreviewBbox: state.rasterArea.childRasterPreviewBbox,
    childGridSize: state.rasterArea.childGridSize,
    childRasterPreview: state.rasterArea.childRasterPreview,
    isChildRasterPreviewVisible: state.rasterArea.isChildRasterPreviewVisible,
  };
};

export default withTranslation()(
  connect(mapStateToProps, null)(NestedRasterGeoJson)
);
